import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useGetUserPropertiesQuery } from "../../features/property/propertyApiSlice";

import SalePerosonalProperty from "../../components/PersonalProperty_ADD/SalePerosonalProperty";
const PersonalAdd = () => {
  const { name } = useSelector((state) => state.user);

  const { data: propertyData } = useGetUserPropertiesQuery(name?._id, {
    skip: !name?._id,
  });

  const values = (propertyData?.data?.Companies || []).filter(
    (prop) => !prop.companyid || prop.companyid === "" || prop.companyid === "undefined" || prop.companyid === "null"
  );

  return (
    <>
      <SalePerosonalProperty values={values} setValues={() => {}} />
    </>
  );
};
export default PersonalAdd;
